import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ContractMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.contract.home);
  };

  return (
    <MainMenuItem
      itemTitleString="契約書を発行"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ContractMenuItem;
